import { CopyOutlined } from '@ant-design/icons'
import { Button, message, Tooltip } from 'antd'
import copy from 'copy-to-clipboard'

interface ButtonCopyProps {
  title?: string
  text: string
  icon?: React.ReactNode
}

const ButtonCopy = ({ title = 'Copy', icon = <CopyOutlined />, text }: ButtonCopyProps) => {
  return (
    <Tooltip title={title}>
      <Button
        type="link"
        icon={icon}
        onClick={() => {
          copy(text)
          message.success('Copied Success!')
        }}
      />
    </Tooltip>
  )
}

export default ButtonCopy
